module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "height": "calc(100vh - 112px)"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center jc-center mt-4"
  }, _vm._l((_vm.lista), function(a, index) {
    return _c('v-card-text', {
      key: index,
      staticClass: "pa-0"
    }, _vm._l((Object.keys(a)), function(r, index2) {
      return _c('div', [_c('v-text-field', {
        attrs: {
          "label": r,
          "dense": "dense"
        },
        model: {
          value: (a[r]),
          callback: function($$v) {
            _vm.$set(a, r, $$v)
          },
          expression: "a[r]"
        }
      })], 1)
    }), 0)
  }), 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "py-2",
    attrs: {
      "block": _vm.isMovil,
      "color": "success",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardar()
      }
    }
  }, [_vm._v("Guardar cambios")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e233f0c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_parametros.vue
// module id = 497
// module chunks = 1